import React from 'react';
import { useFormik } from 'formik';
import {
  InventoryRemoveFormik,
  RemoveStockTransactionAddDto,
  StockTransactionGetDto,
  formikToAddDto,
  RemoveFormikToRemoveDto,
  RemoveDtoToFormik,
  StockTransactionGetDtoToFormik,
} from 'svila-common';
import { useLocation, useHistory } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import { removeSchema } from '../InventorySchema';
import InventoryApi from '../../../../services/api/InventoryApi';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import InventoryRemoveEditForm from '../components/InventoryRemoveEditForm';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import moment from 'moment';

interface ParamProps {
  item: StockTransactionGetDto;
}

export default function InventoryRemoveEdit(): JSX.Element {
  const location = useLocation();
  const history = useHistory();

  const { item } = location?.state ?? {};
  const transaction = item as StockTransactionGetDto;

  const saveItem = async (
    values: InventoryRemoveFormik,
    setSubmitting: (isSubmitting: boolean) => void,
  ): Promise<void> => {
    setSubmitting(true);
    const formData = RemoveFormikToRemoveDto(values);
    const formik = StockTransactionGetDtoToFormik(transaction);
    const addDto = formikToAddDto(formik, transaction.product.genericProductId);
    const templateData = addDto;
    const data: RemoveStockTransactionAddDto = {
      formData,
      templateData,
    };
    const res = await InventoryApi.editRemove(transaction.id, data);
    if (res.status === StatusCodes.OK) {
      history.push(`/inventory/list-for-generic/${transaction.product.genericProductId}`);
    }
    setSubmitting(false);
  };

  const initialValues = RemoveDtoToFormik(transaction);

  const formik = useFormik({
    initialValues,
    validationSchema: removeSchema,
    onSubmit: async (values, { setSubmitting }) => {
      return saveItem(values, setSubmitting);
    },
  });

  return (
    <WhitePad isFluid>
      <TitleComponent
        title="Редактиране"
        onLeftHandler={(): void => {
          history.goBack();
        }}
      />

      <InventoryRemoveEditForm formikProps={formik} />
    </WhitePad>
  );
}
